// TaskEnvLoadingScreen.tsx

import { useEffect, useState } from "react";
import "./TaskEnvLoadingScreen.scss";
import AnswerHubIcon from "../../../../assets/icons/answer-hub-icon.svg?react";

interface TaskEnvLoadingScreenProps {
    onComplete?: () => void;
}

export default function TaskEnvLoadingScreen({
    onComplete,
}: TaskEnvLoadingScreenProps) {
    /** 0 – 100 % */
    const [progress, setProgress] = useState(0);

    /*───────────────────────────────────────────────────────────────
    Random determinate progress
      • total duration:   2 – 4 s   (drawn once)
      • speed “wobbles”   every animation frame
  ───────────────────────────────────────────────────────────────*/
    useEffect(() => {
        const total = 1500 + Math.random() * 1500; // 2 → 4 s
        const start = performance.now();

        const step = (now: number) => {
            const elapsed = now - start;
            const linear = Math.min(elapsed / total, 1); // 0 → 1
            /* add gentle randomness without ever going backwards */
            const noise = (Math.sin(now / 150) + 1) * 0.05; // 0 → 0.1
            const next = Math.min(100, (linear + noise) * 100);

            setProgress((prev) => (next > prev ? next : prev));

            if (linear < 1) {
                requestAnimationFrame(step);
            } else {
                setProgress(100);
                onComplete?.(); // done!
            }
        };

        const id = requestAnimationFrame(step);
        return () => cancelAnimationFrame(id);
    }, [onComplete]);

    return (
        <div className="task-env-loading">
            {/* <p className="task-env-loading__msg">Loading Environment</p> */}

            <div className="task-env-loading__logo">
                <AnswerHubIcon className="answer-hub-icon" />
            </div>

            <div className="task-env-loading__progress-bar">
                <div
                    className="task-env-loading__progress-bar-fill"
                    style={{ width: `${progress}%` }}
                />
            </div>
        </div>
    );
}
